import { render, staticRenderFns } from "./MyBooks.vue?vue&type=template&id=5cb9f404"
import script from "./MyBooks.vue?vue&type=script&lang=js"
export * from "./MyBooks.vue?vue&type=script&lang=js"
import style0 from "./MyBooks.vue?vue&type=style&index=0&id=5cb9f404&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports